import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Button } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import { useWeb5Context } from "../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'FiltersButton');
const getNumberFilters = values => Object.keys(values).reduce((acc, key) => {
  var _values$key;
  return acc + (values[key] !== '' && values[key] !== undefined && values[key] !== null && !Array.isArray(values[key]) && typeof values[key] !== 'boolean' || typeof values[key] === 'boolean' && values[key] !== false || (_values$key = values[key]) !== null && _values$key !== void 0 && _values$key.length ? 1 : 0);
}, 0);
const FiltersButton = _ref => {
  let {
    haveFilters,
    numberFilters,
    openFilters
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const classNames = classnames('filters__toolbar__filter-btn', classes.FiltersButton);
  if (haveFilters) return /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    icon: "filterListActive",
    onClick: openFilters,
    className: classNames
  }, t('label_filters_button', [numberFilters]));
  return !haveFilters && /*#__PURE__*/React.createElement(Button, {
    type: "terciary",
    icon: "filterList",
    onClick: openFilters,
    className: classNames
  }, t('cfm_action_filter'));
};
process.env.NODE_ENV !== "production" ? FiltersButton.propTypes = {
  haveFilters: PropTypes.bool,
  openFilters: PropTypes.func,
  numberFilters: PropTypes.number
} : void 0;
export default /*#__PURE__*/memo(FiltersButton);
export { getNumberFilters };